module.exports = __webpack_public_path__ + "static/image/history/pc/201812.ver2_0_2.jpg?d9adc6ef";